import { mockMirageUsers } from '../fixtures/users';

export const getMirageUser = (id: number) =>
    mockMirageUsers.find(user => user.id === id.toString()) || mockMirageUsers.find(user => user.id === '99999999999')!;
